import { DfyOrderDetailsDto } from "@repo/api/dfy";
import { getDfyRequiredImageCount } from "./dfy-order-selectors";

export function normalizeDfyOrderDetails(details: DfyOrderDetailsDto) {
  if (details.imageSelectionMode === "USER") {
    const cap = getDfyRequiredImageCount(details);
    for (const config of details.sourceImageConfigs
      .filter((item) => item.isSelected)
      .slice(cap)) {
      config.isSelected = false;
    }
  }
}
